module.exports = __webpack_public_path__ + "svg/bomencampus-logo.svg";